import { computed, Injectable, signal } from "@angular/core";
import { CardType } from "../enums/CardType";
import { CardConfig } from "../interfaces/card.interface";

@Injectable({
  providedIn: 'root',
})
export class GroupCardService {

  private readonly card = signal<null | CardConfig>(null);
  private readonly creditsConfig = signal<CardConfig[]>([]);

  selectedCard = this.card.asReadonly();
  configs = this.creditsConfig.asReadonly();

  readonly title = computed(() => {
    switch (this.selectedCard()?.cardType) {
      case CardType.Critico: return "Situação Crítica";
      case CardType.Atencao: return "Necessita Atenção";
      case CardType.Regular: return "Situação Regular";
      case CardType.Excelente: return "Excelente Comportamento";
      default: return "Todos os fatos";
    }
  });

  setCard(cardType: CardConfig | null) {
    this.card.set(cardType);
  }

  setConfigs(cardType: CardConfig[]) {
    this.creditsConfig.set(cardType);
  }



}
